<template>
	<div class="c-field" :class="{'flex-start': !vertical, 'flex-column': vertical}">
		<p class="c-field-label flex-start-center">
			<i v-if="icon" :class="[icon]"></i>
			<label v-if="label">{{label}}：</label>
		</p>
		<div class="c-field-content" :class="{'flex-grow': !vertical}" :style="{'margin-top': vertical ? '.14rem' : 0}"><slot></slot></div>
	</div>
</template>

<script>
	export default {
		name: 'cField',

		props: {
			icon: String,
			label: String,
			vertical: Boolean
		}
	}
</script>

<style lang="stylus" scoped>
	.c-field {
		padding: .04rem 0;
		line-height: .4rem;
		font-size: .28rem;

		&-label {
			gap: .15rem;
		}
	}
</style>
